<template>
  <vee-form v-slot="{ validate }" as="" :initial-errors="initialErrors">
    <form
      ref="formRef"
      class="standard-form"
      method="post"
      :action="`/my/wallet/redeem`"
      @submit.prevent="handleSubmit(validate)"
    >
      <text-input
        v-model="redeemCode"
        input-id="redeemCode"
        label="Enter Code"
        :show-label="false"
        placeholder="xxxx-xxxx-xxxx-xxxx"
        rules="required|max:19"
        validate-as="Code"
        maxlength="19"
        data-hj-suppress
        @input="formatRedeemCode"
      />

      <div class="form-actions">
        <div class="form-action">
          <csrf-input />
          <submit-button
            :submitting="processing"
            label="Redeem Code"
            submitting-label="Processing…"
            classes="-main"
            @submit-action="handleSubmit(validate)"
          />
        </div>
      </div>
    </form>
  </vee-form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Form as VeeForm } from 'vee-validate'
import { errorBagToInitialErrors, initExtraValidationRules } from '@/utils/forms/validation-rules'
import TextInput from '@/components/forms/text-input.vue'
import CsrfInput from '@/components/forms/csrf-input.vue'
import SubmitButton from '@/components/buttons/submit-button.vue'

export default defineComponent({
  name: 'RedeemGiftCode',
  components: {
    VeeForm,
    TextInput,
    CsrfInput,
    SubmitButton,
  },
  props: {
    errorBag: {
      type: Object,
      default: () => ({}),
    },
    initialCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      processing: false,
      redeemCode: this.initialCode,
    }
  },

  computed: {
    // only return first error per field, backend returns array
    initialErrors(): Record<string, string> {
      return errorBagToInitialErrors(this.errorBag)
    },
  },

  watch: {
    // redeemCode: function (input: string) {
    //   // remove any hyphens
    //   input = input.split('-').join('')
    //
    //   // set string to uppercase
    //   input = input.toUpperCase()
    //
    //   // insert hyphen after every 4th character
    //   if (input) {
    //     const matchArr = input.match(/.{1,4}/g)
    //
    //     if (matchArr) {
    //       input = matchArr.join('-')
    //     }
    //   }
    //
    //   this.redeemCode = input
    // },
  },

  // lifecycle methods
  created() {
    // load custom fb* validation rules
    initExtraValidationRules()
  },

  // instance methods
  methods: {
    formatRedeemCode(e: InputEvent) {
      let code = e.target instanceof HTMLInputElement ? `${e.target.value}` : ''

      // remove any hyphens
      code = code.split('-').join('')

      // set string to uppercase
      code = code.toUpperCase()

      // insert hyphen after every 4th character
      if (code) {
        const matchArr = code.match(/.{1,4}/g)

        if (matchArr) {
          code = matchArr.join('-')
        }
      }

      this.redeemCode = code
    },

    async handleSubmit(validate: Function) {
      if (this.processing) {
        return
      }

      this.processing = true

      try {
        const results = await validate()

        // invalid, stop
        if (!results.valid) {
          this.processing = false
          return
        }

        // traditional form submit
        if (this.$refs.formRef instanceof HTMLFormElement) {
          // wait until next tick to make sure v-model update
          await this.$nextTick()
          this.$refs.formRef.submit()
        }
      } catch (e) {
        this.processing = false
      }
    },
  },
})
</script>
